import script from "./GrammarPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrammarPopover.vue?vue&type=script&setup=true&lang=ts"

import "./GrammarPopover.vue?vue&type=style&index=0&id=521425c3&lang=css"
import "./GrammarPopover.vue?vue&type=style&index=1&id=521425c3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521425c3"]])

export default __exports__